import classNames from "classnames";
import React from "react";

import { _RichNavigation__ButtonLink as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { IntrinsicElementProps } from "@thelabnyc/thelabui/src/utils/types";

import styles from "./index.module.scss";

export interface Props {
    value: Value;
    attrs?: IntrinsicElementProps<HTMLElement>;
}

export const RichNavigationButtonLink = (
    props: Props,
): React.JSX.Element | null => {
    const isActive =
        !props.value.promo_period || props.value.promo_period.is_promo_active;
    if (!isActive) {
        return null;
    }
    const classes = classNames({
        button: true,
        [styles.richNavButton]: true,
    });
    return (
        <a href={props.value.destination?.url} className={classes}>
            {props.value.text && <RichTextBlock value={props.value.text} />}
        </a>
    );
};
